import { type CreateMarcoComisionesModel } from "@api/api";

export class CreateMarcoComisiones implements CreateMarcoComisionesModel {

  Denominacion: string = '';

  constructor(data?: Partial<CreateMarcoComisiones>) {
    Object.assign(this, data);
  }
}

